import { render, staticRenderFns } from "./PriceTarget.vue?vue&type=template&id=86315d0e&scoped=true"
import script from "./PriceTarget.vue?vue&type=script&lang=js"
export * from "./PriceTarget.vue?vue&type=script&lang=js"
import style0 from "./PriceTarget.vue?vue&type=style&index=0&id=86315d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86315d0e",
  null
  
)

export default component.exports